import { webApi } from '@lib/api'

export const listTag = ({ id, type }) =>
  webApi({ auth: true }).get(`/v1/site/${id}/tags`, {
    type,
  })
